import { useState } from "react";
import { MAP_POINTS } from "@/lib/data";
import { useLang } from "@/i18n";

/** Interactive equirectangular world map with lat/long-positioned trade nodes. */
const WorldMap = () => {
  const [active, setActive] = useState(0);
  const { t, data } = useLang();
  const labels = data.mapLabels || MAP_POINTS.map((p) => p.label);

  return (
    <div data-testid="interactive-map" className="relative w-full aspect-[2/1] bg-[#ffffff] rounded-2xl border border-[#1d3a1f]/10 card-soft overflow-hidden">
      <img
        src="/worldmap.jpg"
        alt="World map showing Farmsons' Kolkata headquarters and its global sourcing and trade origins"
        className="absolute inset-0 w-full h-full object-cover opacity-30"
        style={{ filter: "grayscale(1) brightness(1.35) contrast(1.05) sepia(0.45) hue-rotate(48deg) saturate(1.4)" }}
        loading="lazy"
      />
      <div className="absolute inset-0 opacity-[0.07]"
        style={{ backgroundImage: "linear-gradient(rgba(255,255,255,.5) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.5) 1px,transparent 1px)", backgroundSize: "48px 48px" }} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#fdfbf5]/60 via-transparent to-[#fdfbf5]/30" />
      <span className="absolute top-4 start-5 z-10 text-xs font-bold tracking-[0.2em] uppercase text-[#5f6b57]">{t("map.title")}</span>

      {MAP_POINTS.map((p, i) => (
        <button
          key={p.label}
          data-testid={`map-point-${p.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
          onMouseEnter={() => setActive(i)}
          onFocus={() => setActive(i)}
          onClick={() => setActive(i)}
          className="absolute -translate-x-1/2 -translate-y-1/2 group z-10"
          style={{ left: `${p.x}%`, top: `${p.y}%` }}
          aria-label={labels[i]}
        >
          <span className={`absolute inset-0 m-auto w-3 h-3 rounded-full ${p.hq ? "bg-[#d3a53a]" : "bg-[#1d3a1f]"}`}
            style={{ animation: "pulse-ring 2s ease-out infinite" }} />
          <span className={`relative block w-3 h-3 rounded-full ${p.hq ? "bg-[#d3a53a]" : "bg-[#1d3a1f]"}`} />
          <span className={`absolute left-1/2 -translate-x-1/2 top-4 whitespace-nowrap text-[10px] md:text-xs font-medium px-2 py-0.5 border border-[#1d3a1f]/10 bg-[#fdfbf5]/90 transition-opacity duration-200 ${active === i ? "opacity-100" : "opacity-0 group-hover:opacity-100"} ${p.hq ? "text-[#d3a53a]" : "text-[#1d3a1f]"}`}>
            {labels[i]}
          </span>
        </button>
      ))}
    </div>
  );
};

export default WorldMap;
